import React from 'react'
import {Link} from "react-router-dom";

export default function CharacterCard({...character}) {
    return (
        <div style={{
            textAlign: 'center',
            background: '#F4F7A1',
            maxWidth: '345px',
            margin: '4px',
            borderRadius: 10,
            display: 'flex',
            flexDirection: 'column'
        }}>
            <div
                style={{
                    width: '100%',
                    height: '100px',
                    display: 'flex',
                    background: 'rgb(211, 93, 25)',
                    borderRadius: 10
                }}
            >
                <div
                    style={{
                        width: 100,
                        transform: 'translate(20px,20px)',
                        borderRadius: '50%',
                        border: '1px solid white',
                        backgroundImage: `url("${process.env.REACT_APP_STATIC_URI}${character.linkImg}")`,
                        backgroundSize: 'cover',
                    }}
                />
                <div style={{width: '60%', display: 'grid', placeContent: 'center', marginLeft: 18}}>
                    <h3>{character.nombres}</h3>
                </div>
            </div>
            <div style={{flexGrow: 1}}>
                <p style={{
                    textAlign: 'justify',
                    minHeight: 120,
                    overflow: 'hidden',
                    color: '#252525',
                    margin: '35px 20px',
                    lineHeight: 1.5
                }}>
                    {character.biografia}
                </p>
            </div>
            <div
                style={{width: '100%', paddingBottom: 20}}
            >
                <Link
                    to={`/character/detail/${character.id}`}>Ver mas</Link>
            </div>
        </div>
    )
}
